import { HelpCenterLocation } from './HelpCenterLocation';

export function getDocumentationLink(location?: HelpCenterLocation) {
  // TODO this is in portal setup too, IIRC.
  const documentationBaseURL = 'https://documentation.decisions.com/v8/docs';
  switch (location) {
    case HelpCenterLocation.Flow:
      return `${documentationBaseURL}/flow-designer-overview`;
    case HelpCenterLocation.Form:
      return `${documentationBaseURL}/about-forms`;
    case HelpCenterLocation.Matrix:
      return `${documentationBaseURL}/about-matrix-rules`;
    case HelpCenterLocation.Page:
      return `${documentationBaseURL}/pages-dashboards`;
    case HelpCenterLocation.Reports:
      return `${documentationBaseURL}/reports`;
    case HelpCenterLocation.StatementRule:
      return `${documentationBaseURL}/rules`;
    case HelpCenterLocation.TruthTable:
      return `${documentationBaseURL}/about-truth-tables`;
    case HelpCenterLocation.SimpleFlow:
      return `${documentationBaseURL}/about-simple-flows`;
    case HelpCenterLocation.SimpleForm:
      return `${documentationBaseURL}/about-simple-forms`;
    case HelpCenterLocation.DataDesigner:
      return `${documentationBaseURL}/data-designer-overview`;
    case HelpCenterLocation.RuleTable:
      return `${documentationBaseURL}/rule-table-overview`;
    case HelpCenterLocation.DiagramTile:
      return `${documentationBaseURL}/diagram-tiles`;
    default:
      return documentationBaseURL;
  }
}
